import { Box, Grid, Typography, styled } from '@mui/material'
import LoadingDot from './LoadingDot'

const InstallingRow = styled(Grid)(({ theme }) => ({
    [theme.breakpoints.down('lg')]: {
        justifyContent: 'center',
    },
    [theme.breakpoints.up('lg')]: {
        justifyContent: 'flex-start',
    },
}))

function Installing() {
    return (
        <Grid item container xs direction="column">
            <InstallingRow item container>
                <Box display="flex">
                    <Typography variant="h4" color="white" align="center">
                        NEW VERSION
                    </Typography>
                </Box>
            </InstallingRow>
            <InstallingRow item container>
                <Box display="flex">
                    <Typography variant={'h6'} color="white" pr={1}>
                        IS INSTALLING{' '}
                    </Typography>
                    <LoadingDot />
                </Box>
            </InstallingRow>
        </Grid>
    )
}
export default Installing
